import BasePostIdApi from "../BasePostIdApi";

export default abstract class BaseCommentApi extends BasePostIdApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/comments`;
	}
}
